import MicrosoftClient from '../MicrosoftClient';

const client = new MicrosoftClient({
  baseUrl: process.env.VUE_APP_APIURL,
  apiClient: 'axios',
  timeout: 30000,
});

export default client;
